import React from "react";
import Loading from "../Loading";

import { Globals } from "../constants";
import "./trivia.css";
import "../App.css";

import PaymentMethods from "./PaymentMethods";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { getCDNUrl } from "../HelperFunctions";

class Wallet extends React.Component {
  constructor(props) {
    super(props);
    let MSISDN = "";
    if (!localStorage.getItem("user")) {
      window.location.href = "/login";
    } else {
      MSISDN = JSON.parse(localStorage.getItem("user")).phone;
    }
    this.state = {
      isLoading: true,
      currentPage: 0,
      prizesData: [],
      msisdn: MSISDN,
      token: JSON.parse(localStorage.getItem("user"))
        ? JSON.parse(localStorage.getItem("user")).xAccessToken
        : "",
      wallet: {},
      page: 1,
      pagesEnd: false,
      tabsIndex: 0,
      prizeOpened: -1,
      transactions: [],
      restrictApi: false,
      isTransactionsLoading: true,
      minimumPayout: 0,
    };

    this.backPressed = this.backPressed.bind(this);
    this.nextPage = this.nextPage.bind(this);
  }

  getWalletAndTransactionInfo = async (page) => {
    let limit = 15;
    let resp = await fetch(
      `${
        Globals.UserManagment
      }api/v1/transactions/get_user_transactions?page=${page}&limit=${limit}`,
      {
        headers: {
          "x-access-token": this.state.token,
          msisdn: this.state.msisdn,
        },
      }
    );
    let data = await resp.json();
    this.setState({
      isLoading: false,
      page: page,
      restrictApi: false,
      pagesEnd: data.data.transactions.length < limit,
      wallet: data.data.wallet,
      transactions: this.state.transactions.concat(data.data.transactions),
      isTransactionsLoading: false,
      minimumPayout: data.data.minWithdrawAmount,
    });

    return data;
  };

  async componentDidMount() {
    if (!this.state.token) {
      window.href = "/login";
    } else {
      this.getWalletAndTransactionInfo(0);
    }
  }

  shouldTokenExpire(timeStamp) {
    let diff = Math.floor((Date.now() - timeStamp) / 1000 / 60 / 60 / 24);
    return diff > 0 ? true : false;
  }

  backPressed(wasTransactionMade) {
    this.setState({
      isLoading: false,
      currentPage: 0,
    });
    if (wasTransactionMade) {
      window.location.reload();
    }
  }

  viewTransactionPressed() {
    this.setState({
      isLoading: true,
      currentPage: 1,
    });
  }

  async nextPage() {
    if (!this.state.pagesEnd) {
      this.setState(
        {
          restrictApi: true,
        },
        () => this.getWalletAndTransactionInfo(this.state.page + 1)
      );
    }
  }

  viewPayoutPressed() {
    this.setState({
      isLoading: false,
      currentPage: 2,
    });
  }

  formatDate(value) {
    let date = new Date(value).toLocaleString();
    return date;
  }

  encrypt(str) {
    return btoa(str);
  }

  TransactionsTab = () => {
    return (
      <div className="">
        <div className="mx-auto wallet-view-transaction pt-2">
          {this.state.transactions.length > 0
            ? this.state.transactions.map((transaction) => {
                return transaction.transactionType === "debit" ||
                  (transaction.transactionType === "credit" &&
                    transaction.winningType === "cash") ? (
                  <div className="ml-2 pt-2" key={transaction.id}>
                    <div style={{ color: "#343434" }} className="row">
                      <div className="d-flex col-8 text-left">
                        <div
                          className="ml-2 my-auto"
                          style={{ fontSize: "14px", fontWeight: "600" }}
                        >
                          {this.formatDate(transaction.createdAt)}
                          {transaction.transactionStatus !== null && (
                            <span
                              style={{ fontSize: "10px", fontWeight: "normal" }}
                              className="transaction-status my-auto ml-5 pt-2 pb-2"
                            >
                              <span style={{ padding: "10px" }}>
                                {transaction.transactionStatus}
                              </span>
                            </span>
                          )}
                        </div>
                        {/* <div
                        className="ml-2"
                        style={{
                          fontSize: "10px",
                          fontWeight: "normal",
                          opacity: "0.5",
                        }}
                      >
                        {this.formatDate(transaction.createdAt)}
                      </div> */}
                      </div>
                      <div className="col-4 text-right">
                        <div
                          className="mr-3"
                          style={{
                            fontSize: "16px",
                            fontWeight: "700",
                            lineHeight: "27px",
                            color:
                              transaction.transactionType === "credit"
                                ? ""
                                : "#b91414",
                          }}
                        >
                          {transaction.transactionType === "credit" ? "+" : "-"}
                          {transaction.amount}
                        </div>
                      </div>
                    </div>
                    <br />
                  </div>
                ) : null;
              })
            : null}
          {!this.state.pagesEnd &&
          !this.state.restrictApi &&
          this.state.transactions.length ? (
            <div>
              <div className="text-center d-none loading-more-results">
                <img src={getCDNUrl("/images/loader_v2.gif")} alt="" height="30" />
              </div>
              <button
                id="more-results"
                onClick={this.nextPage}
                type="button"
                className="btn btn-primary d-none"
              >
                More Results
              </button>
            </div>
          ) : (
            <div />
          )}
        </div>
      </div>
    );
  };

  PrizesTab = () => {
    return (
      <div>
        <div className="mx-auto wallet-view-transaction">
          {this.state.transactions &&
            this.state.transactions.map((transaction, i) => {
              return transaction.transactionType === "credit" ? (
                <div
                  className="ml-2 pt-2"
                  key={transaction.id}
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    this.setState({
                      prizeOpened: i,
                    })
                  }
                >
                  <div style={{ color: "#343434" }} className="row">
                    <div className=" col-11 text-left d-flex">
                      <div className={`my-auto ml-2`}>
                        <img
                          src={
                            transaction.winningType !== "cash"
                              ? getCDNUrl(`/images/wallet/giftBox.png`)
                              : getCDNUrl(`/images/wallet/moneyBag.png`)
                          }
                          alt={`sdkjn`}
                          width={30}
                          height={`auto`}
                        />
                      </div>
                      <div className={`ml-1`}>
                        <div
                          className="ml-2"
                          style={{ fontSize: "14px", fontWeight: "600" }}
                        >
                          {transaction.matchTitle}
                          {transaction.transactionStatus !== null && (
                            <span
                              style={{ fontSize: "10px", fontWeight: "normal" }}
                              className="transaction-status my-2 ml-5"
                            >
                              <span style={{ padding: "10px" }}>{`Rank: ${
                                transaction.winningRank
                              }`}</span>
                            </span>
                          )}
                        </div>
                        <div
                          className="ml-2"
                          style={{ fontSize: "14px", fontWeight: "700" }}
                        >
                          {transaction.winningTitle}
                        </div>
                        <div
                          className="ml-2"
                          style={{
                            fontSize: "10px",
                            fontWeight: "normal",
                            opacity: "0.5",
                          }}
                        >
                          {this.formatDate(transaction.createdAt)}
                        </div>
                      </div>
                    </div>
                    <div className="col-1 text-right d-flex justify-content-end">
                      <div
                        className="mr-3 my-auto"
                        style={{
                          fontSize: "16px",
                          fontWeight: "700",
                          lineHeight: "27px",
                        }}
                      >
                        <i
                          className="fa fa-angle-right float-right"
                          aria-hidden="true"
                        />
                      </div>
                    </div>
                  </div>
                  <br />
                </div>
              ) : null;
            })}
          {!this.state.pagesEnd &&
          !this.state.restrictApi &&
          this.state.transactions.length ? (
            <div>
              <div className="text-center d-none loading-more-results">
                <img src={getCDNUrl("/images/loader_v2.gif")} alt="" height="30" />
              </div>
              <button
                id="more-results"
                onClick={this.nextPage}
                type="button"
                className="btn btn-primary d-none"
              >
                More Results
              </button>
            </div>
          ) : (
            <div />
          )}
        </div>
      </div>
    );
  };

  returnInviteInfoCard = (
    imageSrc = null,
    label = "",
    subLabel = "",
    style = {
      bgCl: "#FDF2F2",
      cl: "#B91414",
    }
  ) => {
    return (
      <div
        className={`text-left d-flex `}
        style={{
          padding: "10px 20px",
          backgroundColor: "red",
          width: "contain",
          borderRadius: "5px",
          backgroundColor: style.bgCl,
        }}
      >
        <div className={`my-auto ml-2`}>
          <img
            src={getCDNUrl(`/images/wallet/${imageSrc}`)}
            alt={`Money Bag`}
            width={20}
            height={`auto`}
          />
        </div>
        <div className={`ml-1`}>
          <div className="ml-2" style={{ fontSize: "14px", fontWeight: "600" }}>
            {label}
          </div>
          <div
            className="ml-2"
            style={{ fontSize: "19px", fontWeight: "800", color: style.cl }}
          >
            {subLabel}
          </div>
        </div>
      </div>
    );
  };

  returnInviteHistoryRow = (
    matchTitle = "003030303030303030",
    date = new Date(),
    prizePoint = "20"
  ) => {
    return (
      <div
        className={`d-flex justify-content-between`}
        style={{
          padding: "20px 30px",
          borderTop: `1px solid #EDF7FE`,
        }}
      >
        <div>
          <div style={{ fontSize: "16px", fontWeight: "600" }}>
            {/* {`User ${user} joined`} */}
            {`${matchTitle}`}
          </div>
          <div
            style={{
              fontSize: "10px",
              fontWeight: "normal",
              opacity: "0.5",
            }}
          >
            {this.formatDate(date)}
          </div>
        </div>
        <div style={{ fontSize: "19px", fontWeight: "800", color: "#0BBA9D" }}>
          {`Rs. ${prizePoint}`}
        </div>
      </div>
    );
  };

  InvitedTab = () => {
    return (
      <div>
        <div className="mx-auto wallet-view-transaction">
          <div className={`d-flex justify-content-center align-items-center`}>
            {/* <div
              className={`d-flex justify-content-between mt-3`}
              style={{
                width: "100%",
                maxWidth: "350px",
              }}
            >
              {this.returnInviteInfoCard(
                "moneyBag.png",
                "People Joined",
                "23",
                {
                  bgCl: "#FDF2F2",
                  cl: "#B91414",
                }
              )}
              {this.returnInviteInfoCard(
                "moneyBag.png",
                "People Joined",
                "23",
                {
                  bgCl: "#DCFFEE",
                  cl: "#0BBA9D",
                },
                false
              )}
            </div> */}
          </div>
          {this.state.transactions.length > 0 ? (
            <div
              className={`d-flex justify-content-between`}
              style={{
                padding: "20px 30px",
              }}
            >
              <h1 className={"font-weight-bold p-2  m-f-14"}>Users</h1>
              <h1 className={"font-weight-bold p-2  m-f-14"}>Prizes</h1>
            </div>
          ) : null}
          {this.state.transactions.length > 0
            ? this.state.transactions.map((transaction) => {
                return transaction.isInvite
                  ? this.returnInviteHistoryRow(
                      transaction.matchTitle,
                      transaction.createdAt,
                      transaction.amount
                    )
                  : null;
              })
            : null}
          {!this.state.pagesEnd &&
          !this.state.restrictApi &&
          this.state.transactions.length ? (
            <div>
              <div className="text-center d-none loading-more-results">
                <img src={getCDNUrl("/images/loader_v2.gif")} alt="" height="30" />
              </div>
              <button
                id="more-results"
                onClick={this.nextPage}
                type="button"
                className="btn btn-primary d-none"
              >
                More Results
              </button>
            </div>
          ) : (
            <div />
          )}
        </div>
      </div>
    );
  };

  prize = () => {
    let prize = this.state.transactions[this.state.prizeOpened];
    return (
      <div
        className=" mb-5"
        style={{
          background: "#FFFFFF",
          borderTopLeftRadius: "35px",
          borderTopRightRadius: "35px",
        }}
      >
        <div className="mx-auto ">
          <div className="mt-4 d-flex justify-content-end">
            <div
              style={{
                fontSize: "20px",
                cursor: `pointer`,
              }}
              onClick={() =>
                this.setState({
                  prizeOpened: -1,
                })
              }
            >
              <i className="fa fa-times-circle mr-3" aria-hidden="true" />
            </div>
          </div>
          <div className="mt-4 text-center">
            <div className="mb-3" style={{ margin: "auto", width: "35%" }}>
              <img
                className="img-fluid"
                src={
                  prize.winningType !== "cash"
                    ? getCDNUrl(`/images/wallet/giftBox.png`)
                    : getCDNUrl(`/images/wallet/moneyBag.png`)
                }
                width={30}
                height={`auto`}
              />
            </div>
            <div>
              <span
                className="d-inline-block"
                style={{
                  fontSize: "36px",
                  fontWeight: "bold",
                  color: "#343434",
                }}
              >
                {prize.winningTitle}
              </span>
              <span
                className="d-inline-block mr-2"
                style={{
                  fontSize: "16px",
                  fontWeight: "bold",
                  color: "#343434",
                }}
              >
                {prize.winningType !== "cash" ? `` : `PKR`}
              </span>
            </div>
            <div className={`w-100 mt-3`} style={{ width: "10%" }}>
              <div className={`d-flex justify-content-between mt-2`}>
                <div className={`ml-4`}>Match</div>
                <div className={`mr-4`}>{prize.matchTitle}</div>
              </div>
              <div className={`d-flex justify-content-between mt-2`}>
                <div className={`ml-4`}>Rank</div>
                <div className={`mr-4`}>{prize.winningRank}</div>
              </div>
              <div className={`d-flex justify-content-between mt-2`}>
                <div className={`ml-4`}>Date</div>
                <div className={`mr-4`}>{this.formatDate(prize.createdAt)}</div>
              </div>
            </div>
            {prize.winningType !== "cash" ? (
              <div className="my-2 mt-3 d-flex justify-content-center">
                <span>
                  <div
                    onClick={() => {
                      if (prize.winningType === "cash")
                        this.viewPayoutPressed();
                      else if (prize.winningUrl)
                        window.open(`${prize.winningUrl}`);
                    }}
                    style={{
                      color: "#F9F9FB",
                      lineHeight: "42px",
                      fontSize: "14px",
                      fontWeight: "bold",
                    }}
                    className="wallet-button my-2"
                  >
                    {prize.winningType !== "cash" ? `Claim` : `Payout`}
                  </div>
                </span>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    );
  };

  MainWallet() {
    return (
      <div id="main-section" className={`w-100`}>
        <Helmet />
        {this.state.isLoading ? (
          <Loading />
        ) : (
          <React.Fragment>
            {Globals.telco !== "mobilink" ? (
              <div
                className="card mb-5"
                style={{ background: "transparent", border: "none" }}
              >
                <div className="mx-auto ">
                  <div className=" my-4 wallet-card text-center">
                    <div
                      className="py-3 mb-4"
                      style={{
                        fontSize: "14px",
                        fontWeight: "bold",
                        color: "#343434",
                      }}
                    />
                    <div
                      className="mb-3"
                      style={{ margin: "auto", width: "35%" }}
                    >
                      <img
                        className="img-fluid"
                        src={getCDNUrl("/images/trivia/assets/wallet.png")}
                      />
                    </div>
                    <div>
                      <span
                        className="d-inline-block mr-2"
                        style={{
                          fontSize: "16px",
                          fontWeight: "bold",
                          color: "#343434",
                        }}
                      >
                        PKR
                      </span>
                      <span
                        className="d-inline-block"
                        style={{
                          fontSize: "36px",
                          fontWeight: "bold",
                          color: "#343434",
                        }}
                      >
                        {this.state.wallet
                          ? this.state.wallet.availableBalance
                          : null}
                      </span>
                    </div>
                    <div
                      style={{
                        fontSize: "14px",
                        fontWeight: "normal",
                        color: "#343434",
                        opacity: "0.5",
                      }}
                    >
                      {this.state.minimumPayout
                        ? `Min amount to payout: ${this.state.minimumPayout}`
                        : null}
                    </div>
                    <div className="my-2 mt-2 text-center mx-auto">
                      <span>
                        <div
                          onClick={() => this.viewPayoutPressed()}
                          style={{
                            color: "#F9F9FB",
                            lineHeight: "42px",
                            fontSize: "14px",
                            fontWeight: "bold",
                            marginLeft: "23%",
                          }}
                          className="wallet-button my-2"
                        >
                          Payout
                        </div>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ) : null}
          </React.Fragment>
        )}
        {this.state.isTransactionsLoading ? (
          <Loading />
        ) : (
          <div
            // id="main-section"
            className="px-lg-0 jc-inner-page align-self-start w-100 m-0"
          >
            {this.state.isLoading ? (
              <div className="main-loader card min-height-80vh">
                <img
                  width="64"
                  height="64"
                  src={getCDNUrl("/images/loader_v2.gif")}
                  alt=""
                />
              </div>
            ) : (
              <div />
            )}

            <div className={`${this.state.customCssTransition} w-100`}>
              <div className="card p-3">
                <div className="d-flex overflow-x-auto">
                  <Link
                    to={`/wallet`}
                    onClick={() =>
                      this.setState({
                        tabsIndex: 0,
                      })
                    }
                  >
                    <h1
                      className={
                        this.state.tabsIndex === 0
                          ? "border-bottom border-danger font-weight-semi-bold p-2  m-f-14"
                          : "font-weight-semi-bold p-2  m-f-14"
                      }
                    >
                      Prizes
                    </h1>
                  </Link>
                  <Link
                    to={`/wallet`}
                    onClick={() =>
                      this.setState({
                        tabsIndex: 1,
                        prizeOpened: -1,
                      })
                    }
                  >
                    <h1
                      className={
                        this.state.tabsIndex === 1
                          ? "border-bottom border-danger font-weight-semi-bold p-2  m-f-14"
                          : "font-weight-semi-bold p-2  m-f-14"
                      }
                    >
                      Transactions
                    </h1>
                  </Link>
                  {Globals.telco !== "mobilink" ? (
                    <Link
                      to={`/wallet`}
                      onClick={() =>
                        this.setState({
                          tabsIndex: 2,
                          // prizeOpened: -1,
                        })
                      }
                    >
                      <h1
                        className={
                          this.state.tabsIndex === 2
                            ? "border-bottom border-danger font-weight-semi-bold p-2  m-f-14"
                            : "font-weight-semi-bold p-2  m-f-14"
                        }
                      >
                        Invited
                      </h1>
                    </Link>
                  ) : null}
                </div>
              </div>

              <div className="mt-2">
                {this.state.prizeOpened !== -1
                  ? this.prize()
                  : this.state.tabsIndex === 0
                    ? this.PrizesTab()
                    : this.state.tabsIndex === 1
                      ? this.TransactionsTab()
                      : this.InvitedTab()}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  ViewPayout() {
    return (
      <PaymentMethods
        msisdn={this.encrypt(this.state.msisdn)}
        walletCash={this.state.wallet.availableBalance}
        backPressed={this.backPressed}
        minimumPayout={this.state.minimumPayout}
        onPayoutClicked={this.getWalletAndTransactionInfo}
      />
    );
  }

  render() {
    return (
      <React.Fragment>
        {Globals.telco !== "mobilink" ? (
          <Helmet>
            <title>{`Cricwick - Wallet`}</title>
            <meta name="description" content={`Cricwick - Wallet`} />
          </Helmet>
        ) : null}
        {this.state.currentPage === 0
          ? this.MainWallet()
          : this.state.currentPage === 1
            ? this.ViewTransaction()
            : this.state.currentPage === 2
              ? this.ViewPayout()
              : null}
      </React.Fragment>
    );
    // if (this.state.currentPage === 0) {
    //   return this.MainWallet();
    // } else if (this.state.currentPage === 1) {
    //   return this.ViewTransaction();
    // } else if (this.state.currentPage === 2) {
    //   return this.ViewPayout();
    // }
    // return null;
  }
}

export default Wallet;
